import React from 'react';

import { LoyaltyPassBarcode } from 'src/assets/loyalty-pass/loyalty-pass-barcode';
import { AppleWalletMobileButton } from 'src/components/loyalty/loyalty-pass/apple-wallet-button';
import { MobileContainer, ContentRow, TextContent, SVGWrapper, Title, Description } from '../styles';

type AddToWalletMobileProps = {
  url: string;
  title: string;
  description: string;
};

export const AddToWalletMobile: React.FC<AddToWalletMobileProps> = ({ url, title, description }): JSX.Element => (
  <MobileContainer>
    <ContentRow>
      <SVGWrapper>
        <LoyaltyPassBarcode />
      </SVGWrapper>
      <TextContent>
        <Title size='medium' tag='h4' weight='bold' lineHeight='1.2'>
          {title}
        </Title>
        <Description size='small' tag='p' weight='regular' lineHeight='1.2'>
          {description}
        </Description>
      </TextContent>
    </ContentRow>
    <AppleWalletMobileButton href={url} />
  </MobileContainer>
);
